import { render, staticRenderFns } from "./BusinessProfile.vue?vue&type=template&id=3053a208&scoped=true&"
import script from "./BusinessProfile.vue?vue&type=script&lang=js&"
export * from "./BusinessProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3053a208",
  null
  
)

export default component.exports